module.exports = __webpack_public_path__ + "static/media/propertyclean.4b47331f.png";